import { Col, Row } from "react-bootstrap";
import { useState } from "react";
import {
  StatisticWidgetVariantValue,
  StatisticTypeWidget,
  E_ContractType,
} from "../types";
import { Overlay, Popover } from "react-bootstrap";
import "./StatisticWidget.css";
import { FormattedMessage } from "react-intl";

export interface IStatisticWidgetParam {
  text: string | "";
  value: React.ReactNode | "";
  helper?: string | "";
  valueVariant:
    | StatisticWidgetVariantValue
    | StatisticWidgetVariantValue.REGULAR;
  typeWidget: StatisticTypeWidget | StatisticTypeWidget.SUNGLASSES;
  contractType: E_ContractType;
}

const StatisticWidget = (props: IStatisticWidgetParam) => {
  const [showHelper, setShowHelper] = useState(false);
  const [targetHelper, setTargetHelper] = useState(null);

  const handlerClickHelper = (e: any) => {
    setShowHelper(!showHelper);
    setTargetHelper(e.target);
  };

  return (
    <>
      <Row className="tag-fitprenda-statistics">
        <Col xs={3} className="my-auto py-2">
          <img
            className="statistic-widget-image"
            alt="Statistic Icon"
            src={
              props.typeWidget === StatisticTypeWidget.SUNGLASSES
                ? "/img/smilling-sunglass.png"
                : props.typeWidget === StatisticTypeWidget.STARSTRUCK
                ? "/img/smilling-star-struck.png"
                : "/img/frowning-face.png"
            }
            width={57.6}
          />
        </Col>
        <Col className="my-auto py-2">
          <Row>
            <Col className="dashboard-widget-widget-questionmark">
              {props.helper ? (
                <>
                  <img
                    src={"img/questionmarkicon.png"}
                    alt="questionmark"
                    className="dashboard-questionmark-size"
                    onClick={(e) => handlerClickHelper(e)}
                  />
                  <Overlay
                    show={showHelper}
                    target={targetHelper}
                    placement={"right"}
                  >
                    <Popover>
                      <Popover.Body>
                        {" "}
                        <FormattedMessage id={props.helper} />
                      </Popover.Body>
                    </Popover>
                  </Overlay>
                </>
              ) : (
                <></>
              )}
              <p className="font-fitprenda-statistics-text">
                <FormattedMessage id={props.text} defaultMessage={props.text} />
              </p>
            </Col>
          </Row>
          <Row>
            <Col className="text-end">
              {props.valueVariant === StatisticWidgetVariantValue.DANGER ? (
                <p className="font-fitprenda-statistics-value-danger">
                  {props.value}
                </p>
              ) : props.valueVariant === StatisticWidgetVariantValue.SUCCESS ? (
                <p className="font-fitprenda-statistics-value-success">
                  {props.value}
                </p>
              ) : (
                <p className="font-fitprenda-statistics-value-regular">
                  {props.value}{" "}
                </p>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default StatisticWidget;
